import { render, staticRenderFns } from "./ProfileCard.vue?vue&type=template&id=746920cc&"
import script from "./ProfileCard.vue?vue&type=script&lang=ts&"
export * from "./ProfileCard.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileCard.vue?vue&type=style&index=0&id=746920cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileAvatar: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/profile/ProfileAvatar.vue').default,CommunityFollowBtn: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/community/CommunityFollowBtn.vue').default})
